export function formatarData(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

export function formatarMoeda(v) {
  return (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export const ROTULOS_SITUACAO = {
  trial: ["Em trial", "bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300"],
  trial_vencido: ["Trial vencido", "bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300"],
  ativa: ["Ativa", "bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300"],
  vencida_carencia: ["Vencida (carência)", "bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300"],
  vencida_bloqueada: ["Vencida (bloqueada)", "bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300"],
  cancelada: ["Cancelada / bloqueada", "bg-gray-200 text-gray-700 dark:bg-white/10 dark:text-gray-300"],
  parceiro: ["Parceiro (free)", "bg-purple-100 text-purple-700 dark:bg-purple-500/20 dark:text-purple-300"],
};
